var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { "tile is-parent is-vertical": true } }, [
    _c(
      "article",
      { class: { "tile is-child box": _vm.isTiled } },
      [
        _vm.isTiled
          ? _c("p", { staticClass: "title" }, [_vm._v("Emails")])
          : _vm._e(),
        _vm._l(_vm.emails, function (email, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !email.isDeleted,
                  expression: "!email.isDeleted",
                },
              ],
              key: email.id,
              staticClass: "field",
            },
            [
              _c("div", { staticClass: "field has-addons" }, [
                _c("p", { staticClass: "control" }, [
                  _c("span", { staticClass: "select" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: email.type,
                            expression: "email.type",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              email,
                              "type",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.emailTypes, function (value, p) {
                        return _c(
                          "option",
                          { key: p, domProps: { value: value } },
                          [_vm._v(_vm._s(p))]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _c("p", { staticClass: "control is-expanded has-icons-left" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: email.address,
                        expression: "email.address",
                      },
                      {
                        name: "fq-validate",
                        rawName: "v-fq-validate",
                        value: _vm.v.$each[index].address,
                        expression: "v.$each[index].address",
                      },
                      {
                        name: "focus-inserted",
                        rawName: "v-focus-inserted",
                        value: { focus: email.isNew },
                        expression: "{ focus: email.isNew}",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "email", placeholder: "Email" },
                    domProps: { value: email.address },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(email, "address", $event.target.value)
                      },
                    },
                  }),
                  _vm._m(0, true),
                ]),
                _c("p", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button is-gold is-outlined",
                      on: {
                        click: function ($event) {
                          return _vm.setDefault(email, index)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon is-medium" }, [
                        _c("i", {
                          staticClass: "mdi mdi-24px",
                          class: [
                            email.isDefault ? "mdi-star" : "mdi-star-outline",
                          ],
                        }),
                      ]),
                    ]
                  ),
                ]),
                _c("p", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button is-danger is-outlined",
                      on: {
                        click: function ($event) {
                          return _vm.deleteEmail(email, index)
                        },
                      },
                    },
                    [_vm._m(1, true)]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                !_vm.v.$each[index].address.required
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Email Address field is required"),
                    ])
                  : _vm._e(),
                !_vm.v.$each[index].address.email &&
                _vm.v.$each[index].address.required
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Email Address field is invalid"),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        }),
        _c("div", { staticClass: "field" }, [
          _c("p", { staticClass: "control is-pulled-right" }, [
            _c(
              "a",
              {
                staticClass: "button is-primary tooltip is-tooltip-topright",
                attrs: {
                  disabled: _vm.v.$invalid,
                  "data-tooltip": "Add new email",
                },
                on: {
                  click: function ($event) {
                    return _vm.addEmail()
                  },
                },
              },
              [_vm._m(2)]
            ),
          ]),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small is-left" }, [
      _c("i", { staticClass: "mdi mdi-email mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }